import React from 'react'
import { ExchangerTransfersList } from './list/page'
export const ExchangerTransfersPage = (): JSX.Element => {
  return <ExchangerTransfersList />
}
